import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=43559ee4&scoped=true"
import script from "./InfoMessage.vue?vue&type=script&lang=js"
export * from "./InfoMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43559ee4",
  null
  
)

export default component.exports